<template>
  <Card class="cta-card" :style="styles">
    <CardText>
      <VText variant="h2" color="#465049" style="margin-bottom: 0.75rem">{{
        title
      }}</VText>
      <div class="cta-card__grid">
        <div class="cta-card__img">
          <nuxt-img loading="lazy" v-bind="imgProps" />
        </div>
        <div>
          <VText variant="h3" color="primary" style="margin-bottom: 0.75rem">
            Social media done with you for your small business</VText
          >
          <VText color="#465049" style="margin-bottom: 1rem">
            The Social Club is a monthly membership designed for small business
            owners who know they should be promoting their brand on social media
            but either a.) don’t know how, b.) don’t love social media, c.)
            think it used to be fun but not anymore, or d.) simply don’t have
            the time or energy to keep up with social planning on their own.
          </VText>

          <Button :href="Url" color="white">{{ buttonText }}</Button>
        </div>
        <VText style="margin-top: 0.5rem; font-size: 0.85rem">
          <a
            style="color: #ffffff"
            href="https://www.hellosmallstudio.com/terms-conditions"
            >terms apply</a
          ></VText
        >
        <VText variant="h4" color="primary" style="margin-bottom: 0.75rem">
          Use Promo Code CAMPSITE</VText
        >
      </div>
    </CardText>
  </Card>
</template>

<script>
import tinyColor from 'tinycolor2';
import {
  useTheme,
  Card,
  CardText,
  VText,
  Button,
} from '@campsite-bio/component-lib';
import { computed } from '@nuxtjs/composition-api';

export default {
  name: 'PromoBox',

  components: {
    Card,
    CardText,
    VText,
    Button,
  },

  props: {
    imgProps: {
      type: Object,
      default: null,
    },

    title: {
      type: String,
      required: true,
    },

    buttonText: {
      type: String,
      required: true,
    },

    Url: {
      type: String,
      required: true,
    },
  },

  setup() {
    const theme = useTheme();

    const styles = computed(() => {
      return {
        '--c-bg-color': tinyColor(theme.value.colors.primary)
          .setAlpha(0.05)
          .toRgbString(),
      };
    });

    return {
      styles,
    };
  },
};
</script>

<style lang="scss" scoped>
.cta-card {
  &__grid {
    display: grid;
    gap: 1rem;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 2fr;
      grid-gap: 2.5rem;
    }
  }

  &__img {
    align-self: center;
    text-align: center;

    img {
      border: none;
      margin: 0;
    }
  }
  button {
    margin: 1rem 0;
    text-align: center;
  }
}

.cta-card.cta-card {
  background: #c2d4a1;
  border-radius: var(--g-border-radius-standard);
  border-radius: Min(
    var(--g-border-radius-standard),
    var(--g-border-radius-min)
  );
  margin: 2rem 0;

  h2 {
    margin: 0;
  }

  ul {
    columns: 2;
    list-style: none;
    margin: 1rem 0 0;
    padding: 0;
  }

  li {
    padding: 0.2rem 0;
  }
}

.success {
  color: var(--g-color-success);
  font-weight: 700;
}

.error {
  color: var(--g-color-error);
  font-weight: 700;
}
</style>
